module.exports = __webpack_public_path__ + "img/features_header_pengaturan.fbce86d3.png";